import React, {useEffect, useState} from "react";
import eventimg from '../assets/images/eventimg.webp';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import 'aos/dist/aos.css';
const Events = () =>{
  const [showloading, setshowloding] = useState(false);
  const [fetcheddata, setfetcheddata] = useState([]);
  const navigate = useNavigate();

  const fetchcommiteedata = async() => {
      setshowloding(true);
      const headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let resp = await axios
        .get(apiUrl + "getuserevents", headers)
        .then((res) => {
          if (res.data.status == "success" && res?.data?.data?.length > 0) {
              setfetcheddata(res?.data?.data)
              setshowloding(false);
          } else {
              setfetcheddata([])
              setshowloding(false);
          }
        })
        setshowloding(false);

  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();
  
    // Get ordinal suffix
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  }

  const handleclickjournal = (journal) => {
      if(journal) {
          // navigate(assetsUrl+'ijcapjournals/'+journal);
          window.open(assetsUrl + 'ijcapjournals/' + journal, '_blank');
      }
  }

  useEffect(() => {
                          AOS.init();
                          AOS.refresh();
                          fetchcommiteedata();
                      }, [])

    return(
        <div>
<section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">Events</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                    Events</p>
                </div>
            </section>
            <section className="musem-main-sec  ">


    <div className="container">
    <p className="home-about-head text-center musem-head-color">SVU Zoology Dept. Events</p>
    <p className="museum-main-para text-center">SVU Zoology Dept. Events
    Stay updated with the latest events, workshops, and seminars hosted by the SVU Zoology Department. Our events aim to promote research, conservation, and awareness in the field of zoology.</p>


    <div className="row  event-card-box">

      {
        fetcheddata?.length > 0 ?
        fetcheddata?.map((item, index) => {
          return (
            <div className="col-md-4" key={index}>
            <div className="cardd">
              <div className="">
                <img src={assetsUrl+'events/'+item?.image} className="event-card-img" alt="Event 5" />
                <span className=" event-year">{formatDate(item?.date)}</span>
              </div>

            </div>
            <div className="card-body">
                <p className="card-body-para">{item?.subtext}</p>
                <p className="card-body-eventno">{item?.name}</p>
              </div>
          </div>
          )
        }) : 
        showloading ?
        <div>
             <Spinner color='#264790' size={22} className='spinnerCenter' />
        </div>
        :
        <p className="alumini-comitee-member-name" style={{textAlign: 'center'}}>No events added</p>
      }
        

          

          </div>
 </div>
</section>
        </div>
    )
}
export default Events